module.exports = __webpack_public_path__ + "img/market.b231e9eb.svg";